import { Youtube } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#F4F4F5] border-t border-black/10 py-12"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div>
                    <div className="font-display font-black text-lg tracking-tight text-zinc-950">
                        RANE<span className="text-[#FF5500]">.</span>DYNAMICS
                    </div>
                    <div className="text-xs text-zinc-500 mt-1 tracking-wide">
                        Decentralized Abundance Engineering · © {new Date().getFullYear()}
                    </div>
                </div>
                <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.2em] text-zinc-500">
                    <a href="#about" data-testid="footer-link-about" className="hover:text-[#FF5500]">
                        About
                    </a>
                    <a href="#trilogy" data-testid="footer-link-trilogy" className="hover:text-[#FF5500]">
                        Trilogy
                    </a>
                    <a href="#movies" data-testid="footer-link-movies" className="hover:text-[#FF5500]">
                        Films
                    </a>
                    <a
                        href="#engineering"
                        data-testid="footer-link-engineering"
                        className="hover:text-[#FF5500]"
                    >
                        Engineering
                    </a>
                    <a href="#contact" data-testid="footer-link-contact" className="hover:text-[#FF5500]">
                        Contact
                    </a>
                    <a
                        href="https://www.youtube.com/@ranedynamics"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-link-youtube"
                        className="inline-flex items-center gap-2 text-zinc-950 hover:text-[#FF0000] transition-colors"
                    >
                        <Youtube size={14} />
                        YouTube
                    </a>
                </div>
            </div>
        </footer>
    );
}
